import React, { useContext, useState, useEffect, useRef } from 'react'
import { useTranslation } from 'react-i18next'

import { LoginWrapper } from '../Components/Login/Login'
import { LoginPasswordForm } from '../Components/Login/LoginPasswordForm'
import { useNavigate } from 'react-router-dom'
import { UserContext } from '../Providers/UserProvider'
import { LoginSignatureForm } from '../Components/Login/LoginSignatureForm'
import { Language } from '../Components/Login/Language'
import { Logo } from '../Components/Login/Logo'
import { HelpText } from '../Components/Login/HelpText'
import { LoginFormWrapper } from '../Components/Login/LoginFormWrapper'
import { LoginRecoverForm } from '../Components/Login/LoginRecoverForm'
import UserService from '../Services/UserService'
import useMessage from '../Hooks/useMessage'

export function LoginContainer() {
	let navigate = useNavigate()
	const { t, i18n } = useTranslation()
	const [incorrectLoginAttempts, setIncorrectLoginAttempts] = useState(0)
	const [loginFailTimer, setLoginTimer] = useState(0)
	const { user, login } = useContext(UserContext)
	const { addMessage } = useMessage()
	const [authType, setAuthType] = useState('PASSWORD') //PASSWORD or SIGN
	const [username, setLogin] = useState('')
	const [password, setPassword] = useState('')
	const [loading, setLoading] = useState(false)
	const [email, setEmail] = useState('')
	const [saveMe, setSaveMe] = useState(false)
	const [connectedPKI, setConnectedPKI] = useState(false)

	const changeLanguage = language => {
		i18n.changeLanguage(language)
	}

	const toggleSaveMe = () => {
		setSaveMe(!saveMe)
	}
	const handleLogin = e => {
		setLogin(e.target.value)
	}
	const handlePassword = e => {
		setPassword(e.target.value)
	}
	const handleEmail = e => {
		setEmail(e.target.value)
	}

	const handleSubmit = e => {
		e.preventDefault()
		setLoading(true)
		UserService.postLogin({ email: username, password }).then(
			response => {
				if (response?.data?.data) {
					login(response?.data?.data)
					localStorage.setItem(
						'bolashak_token',
						JSON.stringify(response?.data?.access_token)
					)
					addMessage(
						localStorage.getItem('i18nextLng') == 'ru' ? 'Привет!' : 'Салем!',
						'success'
					)
					switch (response?.data?.data?.roles[0]) {
						case 'challenger':
							navigate('/challenger/notifications')
							break
						case 'administrator':
							navigate('/admin/statistic')
							break
						case 'system_administrator':
							navigate('/sysadmin/users')
							break
						case 'expert':
							navigate('/expert/interview')
							break
						case 'technical_secretary':
							navigate('/secretary/interviews')
							break
						default:
							break
					}
				}
				// window.location.reload();
			},
			error => {
				setLoading(false)
				// setIncorrectLoginAttempts(prevState => prevState + 1)
				if (error?.response?.data?.seconds) {
					setIncorrectLoginAttempts(3)
					setLoginTimer(error?.response?.data?.seconds)
				}
			}
		)
	}

	useEffect(() => {
		if (loginFailTimer === 0) {
			setIncorrectLoginAttempts(0)
			return
		} else {
			// TODO: Сделать через worker время вне фокуса в 2 раза дольше, в сафари наверное еще хуже
			const interval = setInterval(() => {
				setLoginTimer(prev => prev - 1)
			}, 1000)
			console.log(interval)
			return () => clearInterval(interval)
		}
	}, [loginFailTimer])

	// const loginFailTimerController = () => {
	// 	intervalId.current = setInterval(() => {
	// 		setLoginTimer(prev => prev - 1)
	// 	}, [1000])
	// }

	const handlePKISubmit = e => {
		e.preventDefault()
		if (window.ncalayer_ready) {
			const data = {
				module: 'kz.gov.pki.knca.commonUtils',
				method: 'signXml',
				args: [
					'PKCS12',
					'AUTHENTICATION',
					'<login><sessionid>caacda70-fd36-45ed-8d94-45a88890f83a</sessionid></login>',
					'',
					'',
				],
			}
			window.ncalayer_websocket.send(JSON.stringify(data))
		} else {
			addMessage('Убедитесь, что программа NCALayer запущена', 'warn')
		}
	}

	const handleRecoverSubmit = e => {
		e.preventDefault()
		setLoading(true)
		UserService.recoverByEmail({ email }).then(
			response => {
				if (response?.data?.message) {
					localStorage.removeItem('bolashak_token')
					addMessage(response?.data?.message, 'success')
					setLoading(false)
					setAuthType('PASSWORD')
				}
			},
			error => {
				setLoading(false)
			}
		)
	}

	useEffect(() => {
		if (authType == 'SIGN' && !connectedPKI) {
			window.ncalayer_websocket = new WebSocket('wss://127.0.0.1:13579/')
			window.ncalayer_websocket.onopen = () => {
				window.ncalayer_ready = true
				setConnectedPKI(true)
			}
			window.ncalayer_websocket.onmessage = e => {
				const response = JSON.parse(e.data)
				//  addMessage(response, "status");

				if (response.responseObject) {
					// response.responseObject;
					UserService.postPKI({ data: response.responseObject }).then(
						response => {
							if (response?.data?.data) {
								login(response?.data?.data)
								localStorage.setItem(
									'bolashak_token',
									JSON.stringify(response?.data?.access_token)
								)
								addMessage(
									localStorage.getItem('i18nextLng') == 'ru'
										? 'Привет!'
										: 'Салем!',
									'success'
								)
								switch (response?.data?.data?.roles[0]) {
									case 'challenger':
										navigate('/challenger/')
										break
									case 'admin':
										navigate('/admin/statistic')
										break
									case 'system_administrator':
										navigate('/sysadmin/users')
										break
									case 'expert':
										navigate('/expert/interview')
										break
									case 'technical_secretary':
										navigate('/secretary/')
										break
									default:
										navigate('/')
										break
								}
							}
							// window.location.reload();
						},
						error => {
							setLoading(false)
						}
					)
				}
			}
		}
	}, [authType])

	return (
		<LoginWrapper>
			<Language changeLanguage={changeLanguage} />
			<Logo />
			<HelpText />
			<LoginFormWrapper authType={authType} setAuthType={setAuthType}>
				<LoginPasswordForm
					login={username}
					password={password}
					handleLogin={handleLogin}
					handlePassword={handlePassword}
					handleSubmit={handleSubmit}
					setAuthType={setAuthType}
					saveMe={saveMe}
					toggleSaveMe={toggleSaveMe}
					incorrectLoginAttempts={incorrectLoginAttempts}
					loginFailTimer={loginFailTimer}
					loading={loading}
				/>
				<LoginSignatureForm handlePKISubmit={handlePKISubmit} />
			</LoginFormWrapper>
			<LoginRecoverForm
				handleEmail={handleEmail}
				email={email}
				handleRecoverSubmit={handleRecoverSubmit}
				authType={authType}
				setAuthType={setAuthType}
			/>
		</LoginWrapper>
	)
}
